<script>
  import * as Constants from '../Constants';
  import * as Utils from '../services/Utils';
  import { _ } from '../services/i18n';

  // Item
  import { getContext } from 'svelte';
  const { open } = getContext('simple-modal');
  import GalleryToolsItem from './GalleryToolsItem.svelte';
  
  let items = [];
  let loading = false;
  let error = false;

  function fetchItems() {
    loading = true;
    Utils.fetchData(Constants.HOST_SERVICES + 'getTools')
        .then(response => response.json())
        .then(response => items = response.result.items)
        .catch(error => {
          error = true;
          console.error(error);
        })
        .finally(() => {
          loading = false;
        });
  }
  
  fetchItems();

	const showItem = (name, link) => {
    if (typeof link !== 'undefined' && link) {
      window.open(link, '_blank');
    } else {
      open(GalleryToolsItem, { name: name });
    }
	};
</script>

<!-- HTML ----------------------------------------------------------------------->
<div id="container" class="fadeIn def_back gallery-tools">
  {#each Constants.GALLERY_TOOLS_TYPES as TYPE}
    <div class="graphic_sezs {TYPE}">
      <div class="tools_headers">
        <h2 class="titles">{TYPE}</h2>
      </div>
      
      {#if loading}
      <!-- thumbs[TYPE].length === 0 && !galleryError -->
        <div class="lds-css">
          <div class="lds-eclipse"><div></div></div>
        </div>
        
      {:else if items}
        {#each items[TYPE] as elem}
          <div class="tools_rows {elem.type.toLowerCase()}" on:click={showItem(elem.name, elem.link)}>
            <!--(click)="showItem(tool.name, tool.link)">-->
            <div class="tool_header">
              <span class="tools_titles def_back">
                {@html elem.title}
              </span>
              <span class="tools_year def_back">{elem.year}</span>
              {#if elem.link}
                <i class="fas fa-external-link-alt"></i>
              {/if}
<!--              <i class="fab {(elem.type !== 'PHP') ? 'fa-3x' : 'fa-2x'}-->
<!--                  fa-{elem.type.toLowerCase()} {elem.type.toLowerCase()} tools_types"></i>-->
            </div>
              <!--{#if elem.icon}-->
              <!--  <span class="tools_imgs" id="tools-{elem.name}"></span>-->
              <!--{/if}-->
            <p>
              {elem.desc_en}
            </p>
          </div>
        {/each}

      {:else if error}
        <div class="gallery-error">
          <i class="far fa-times-circle"></i>
          {$_('errors.UNKNOWN')}
        </div>
      {/if}
    </div>
  {/each}
</div>

<!-- STYLES ----------------------------------------------------------------------->
<style type="text/scss">
@import '../../public/styles/variables';
@import '../../public/styles/mixins';

$type-transp: 0.4;
$type-darken: 0;

#container .tools_sezs {
  margin: 0 0 55px;
}
.tools_rows {
  cursor: pointer;
  display: block;
  margin: 0 auto 19px;
  padding: 5px 0 5px 5px;
  text-align: left;
  width: 80%;
  height: auto;
  min-height: 85px;
  @include box-shadow(0 0 7px 0 transparentize(black, 0.5));
  /* background-image: url("https://tools.obyte.it/img/idrobyte/backgroundscuro.png"); */
  background: transparentize($idro-palette-dark-background, 0.7);
  border: 2px solid transparentize($idro-skill-html5, $type-transp);
  border-radius: 24px;
  @include transition(all 0.5s ease-in-out);
  // &.java { border-color: transparentize($idro-skill-java, $type-transp); }
  // &.android { border-color: transparentize($idro-skill-android, $type-transp); }
  // &.html5 { border-color: transparentize($idro-skill-html5, $type-transp); }
  // &.js { border-color: transparentize($idro-gallery-js, $type-transp); }
  // &.php { border-color: transparentize($idro-skill-php, $type-transp); }
  // &.spring, &.spring_boot { border-color: transparentize($idro-skill-spring, $type-transp); }
  @include border-radius(24px);
  .tools_titles {
    font-weight: bold;
    display: inline-block;
    line-height: 28px;
    font-size: 14px;
    padding: 0 0 0 18px;
    margin: 0 0 3px 8px;
    width: 260px;
    height: 28px;
    @include border-radius(10px);
  }
  .tools_year {
    border-radius: 10px;
    padding: 0 8px;
    margin-left: 10px;
    border: 1px solid transparentize($idro-palette-second, 0.3);
  }
  .fa-external-link-alt {
    margin: 7px 0 7px 10px;
    position: absolute;
  }
  .tools_imgs {
    float: left;
    width: 50px;
    height: 50px;
    margin: 2px 7px 0 17px;
    background: url("https://tools.obyte.it/img/idrobyte/miniLoghiTools.png") no-repeat
  }
  .tools_types {
    &.java { color: darken($idro-skill-java, $type-darken) }
    &.android { color: darken($idro-skill-android, $type-darken) }
    &.html5 { color: darken($idro-skill-html5, $type-darken) }
    &.js { color: darken($idro-gallery-js, $type-darken) }
    &.php { color: darken($idro-skill-php, $type-darken) }
    &.spring, &.spring_boot {
      color: darken($idro-skill-spring, $type-darken);
      background-image: url('https://tools.obyte.it/img/idrobyte/icon-spring-boot-green.svg');
      background-size: 100%;
      background-repeat: no-repeat;
      width: 35px;
      height: 35px;
      display: inline-block;
      margin: 7px 6px 0;
    }
    float: right;
    display: inline;
    margin: 2px 5px 0 10px;
    line-height: 40px;
    height: 40px;
    width: 40px;
    @include border-radius(10px);
    color: #fff;
    cursor: default;
    text-align: center;
    text-shadow: 2px 1px 2px transparentize(black, 0.45);
  }

  &:hover {
    background: lighten(transparentize($idro-palette-dark-background, 0.85), 40%);
    .tools_titles {
      background-color: transparentize(lighten($idro-palette-second, 20%), .8);
    }
  }
  #tools- {
    &accessLogReader {background-position:0 -200px}
    &jmsAgentReader {background-position:0 -150px}
    &webTools {background-position:0 -100px}
    &myMonReader {background-position:0 -50px}
    &spaceBreakers {background-position:0 0}
  }
}

/******************************
*********** MOBILE ***********
******************************/
@media #{$mobile} {
  .tools_rows {
    padding: 12px 0 15px 5px;
    height: 100%;
    min-height: 90px;
    .tools_headers {
      height: 100%
    }
    .tools_titles {
      width: 50%;
      height: auto;
      display: inline-block;
    }
  }
}
@media #{$tablet-m} {
  .tools_rows {
    min-height: 95px;
    .tools_titles {
      width: 48%;
      height: auto;
      display: inline-block;
    }
  }
}
</style>
